/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// material
import { Page, Content, InContentMessage } from '@insticator/insticator-ui'; // iui-material
import Header from '../../../material/structure/header/header';
import PageHeader from '../../../material/structure/pageheader/pageheader';
import PageContent from '../../../material/structure/pagecontent/pagecontent';
import RevenueReportSection from './revenuereportsection/revenuereportsection';
import RevenueDrivers from './revenuedrivers/revenuedrivers';
import RevenueDriversBeta from './revenuedrivers/revenuedrivers_beta'
import RevenueFilter from '../../../material/globalfilter/globalfilter';
// utils
import { serialize } from '../../../utils/serialize';
import { getDevices } from '../../../utils/filterhelpers';
// thunks
import { fetchRevenueDetailData } from '../../../state/thunks/revenue';
// styles
import injectSheet from 'react-jss';
import styles from './overview_styles';
import {
    fetchPublisherPageviewForStackedCharts,
    fetchPublisherRevenueForOverview,
    fetchPublisherRevenueForStackedCharts
} from "../../../state/thunks/revenue_overview";
// static
import {
    DEVICE,
    GEO,
    SITE,
    NET_REVENUE,
    PRODUCT_TYPE,
    REVENUE_TYPE,
    AVG_RPM,
    PAGE_VIEWS,
} from "../monetization/consts";
import {TOOLTIP_CONTENTS_LEGACY, TOOLTIP_CONTENTS} from "./revenuedrivers/tooltip_text";
import {DATE} from "../reportbuilder/monetizationform/consts";


/* ========== ~~~~~~~~~~ OVERVIEW ~~~~~~~~~~ ========== */
export default injectSheet(styles)(({ classes }) => {
    const accountUUID = useSelector((state) => state.session.accountUUID);
    const sitesAndAppsUUIDs = useSelector((state) => state.account.sitesAndAppsUUIDs)
    const { sites, dateRange, devices, compareTo, countries } = useSelector((state) => state.app.filters);

    const lastUpdated = useSelector((state) => {
        return state.revenueOverview.overviewChart.lastUpdated;
    });
    const requestStatus = useSelector((state) => {
        return state.revenueOverview.overviewChart.status
    });

    const { showMessage, message } = useSelector((state) => state.settings.notificationsConfig)

    // actions
    const dispatch = useDispatch();

    useEffect(() => {
        requestRevenueData()
    }, [sites, devices, compareTo, countries]);

    const getParams = (type) => {
        const base = ({
            accountUUID,
            siteUUIDs: sites,
            dimension: REVENUE_TYPE,
            startDate: dateRange.from,
            endDate: dateRange.to,
            metrics: [NET_REVENUE],
            filters: {
                [SITE]: sites.length ? sites : [...Object.keys(sitesAndAppsUUIDs || {})],
                [DEVICE]: getDevices(devices, 'monetization').length ? getDevices(devices, 'monetization') : undefined,
                [GEO] : countries.length ? countries : undefined,
            },
            compareTo: compareTo,
        })

        switch (type) {
            case 'revenue':
                return base
            case 'product':
                return {...base, dimension: PRODUCT_TYPE}
            case 'pageview':
                return {...base, dimension: DATE, metrics: [AVG_RPM, PAGE_VIEWS]}
        }
    };

    // data
    const requestRevenueData = () => {
      if (requestStatus === 'pending' || dateRange.from === null || dateRange.to === null) return null;
      dispatch(fetchPublisherRevenueForOverview(getParams('revenue')));
      dispatch(fetchPublisherRevenueForStackedCharts(getParams('product')));
      dispatch(fetchPublisherPageviewForStackedCharts(getParams('pageview')));
    };

    const getRevenueRequestData = () => {
        return serialize({
            accountUUID,
            siteUUIDs: sites,
            startDate: dateRange.from,
            endDate: dateRange.to,
            devices: getDevices(devices, 'monetization'),
            compareTo: compareTo,
            countries: countries
        })
    };


    return (
      <Page name={`overview`} klass={classes.overview}>
        <Header>
          <RevenueFilter onFilterApply={requestRevenueData} />
        </Header>
        <Content>
          <InContentMessage />
          <PageHeader
            title={'Overview'}
            dataTip={true}
            lastUpdatedTimestamp={lastUpdated}
            bannerText={showMessage ? message : null}
            ignoreDataTip={showMessage}
          />
          <PageContent>
            <RevenueReportSection />
            <RevenueDriversBeta
              title={'Revenue Drivers'}
              dateRange={'Week 31, 2020'}
              tooltipContent={TOOLTIP_CONTENTS}
              getParams={getParams}
            />
          </PageContent>
        </Content>
      </Page>
    )
});
